import { Orientation } from "../../../interfaces";

export default {
  // Team Tailor
  0x00: {
    thumbnail: '/assets/images/thumbnails/Video/julian.jpg',
    url: 'http://www.youtube.com/embed/vGfPhJdHBR8',
    orientation: Orientation.WEST
  },
  // Mac Cheese
  0x01: {
    thumbnail: '/assets/images/thumbnails/Video/martin.jpg',
    url: 'https://www.youtube.com/embed/hUPFqxXGm-Q',
    orientation: Orientation.SOUTH
  },
  // Team X
  0x02: {
    thumbnail: '/assets/images/thumbnails/Video/vid_ideation_council.jpg',
    url: 'https://www.youtube.com/embed/cm6a5MA2on4',
    orientation: Orientation.SOUTH
  },
  0x04: {
    thumbnail: '/assets/images/thumbnails/Video/vid_blockchain.jpg',
    url: 'https://www.youtube.com/embed/SjyGemc0bHc',
    orientation: Orientation.SOUTH
  },
  0x05: {
    thumbnail: '/assets/images/thumbnails/Video/vid_wall.jpg',
    url: 'https://www.youtube.com/embed/76WSEx3Vc5w',
    orientation: Orientation.SOUTH
  },
  0x06: {
    thumbnail: '/assets/images/thumbnails/Video/vid_ai.jpg',
    url: 'https://www.youtube.com/embed/m_lUtBvEfrU',
    orientation: Orientation.WEST
  },
  0x07: {
    thumbnail: '/assets/images/thumbnails/Video/vid_culture.jpg',
    url: 'https://www.youtube.com/embed/Zl-tcle9PVk',
    orientation: Orientation.SOUTH
  },
  0x08: {
    thumbnail: '/assets/images/thumbnails/Video/vid_nav.jpg',
    url: 'https://www.youtube.com/embed/1Nw8za2vsAk',
    orientation: Orientation.WEST
  },
}